<label>Show
  <!--suppress TypeScriptUnresolvedVariable -->
  <select (change)="select($event.target.value)">
    <option *ngFor="let option of options" [value]="option">{{ option }}</option>
  </select> entries
</label>
